import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { baseFetch } from "../helpers/apiClient";
import flightIcon from "../assets/images/flight-icon-with-bg.png";
import moment from "moment";

const IntroductoryOfferModal = ({
  open,
  onClose,
  pack,
  handleBack,
  selectedPlan,
}) => {
  const [retentionPlans, setRetentionPlans] = useState([]);
  const duration = pack?.name === "Echo Access Pass" ? " 3-month" : "one-year";

  useEffect(() => {
    const fetchRetentionPlans = async () => {
      baseFetch({
        url: `/v1/web/retention/plans`,
        method: "GET",
      }).then((response) => {
        console.log("response is", response);
        setRetentionPlans(response?.data?.allRetentionPlans?.prices || []);
      });
    };
    fetchRetentionPlans();
  }, []);

  const totalMonths =
    selectedPlan === "monthly"
      ? 1 + (pack?.introductoryOffer?.freeMonths || 0)
      : 12 + (pack?.introductoryOffer?.freeMonths || 0);

  const futureDate = moment().add(totalMonths, "months").format("DD MMM YYYY");

  const isIntroOfferActive = pack?.introductoryOffer?.isActive;

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "40px",
          maxWidth: {
            xs: "95%",
            sm: "550px",
            md: "650px",
            lg: "750px",
            xl: "850px",
          },
          margin: { xs: "15px" },
          maxHeight: {
            xs: "calc(100vh - 30px)",
            sm: "calc(100vh - 64px)",
          },
          "& .MuiDialogContent-root": { padding: 0 },
        },
      }}
      BackdropProps={{
        sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
      }}
    >
      <DialogContent>
        <Box sx={{ position: "relative" }}>
          {isIntroOfferActive ? (
            <>
              {/* ---- Original Introductory Offer Content ---- */}
              <Box>
                <Box sx={{ marginBottom: "18px" }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2A4876",
                      fontSize: {
                        xs: "18px",
                        sm: "20px",
                        md: "24px",
                        lg: "28px",
                        xl: "32px",
                      },
                    }}
                  >
                    Special Introductory Offer for {pack?.name} Users!
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: "5px" }}>
                  <Typography
                    sx={{
                      color: "#000000B2",
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "14px",
                        lg: "16px",
                        xl: "18px",
                      },
                      fontWeight: 400,
                      marginBottom: "15px",
                    }}
                  >
                    Thank you for choosing the {pack?.name}! We’re excited to
                    have you on board and are thrilled to offer you a special
                    introductory benefit.
                  </Typography>
                  <Typography
                    sx={{
                      color: "#000000B2",
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "14px",
                        lg: "16px",
                        xl: "18px",
                      },
                      fontWeight: 400,
                      marginBottom: "15px",
                    }}
                  >
                    At the end of your {duration} subscription, your content
                    will remain available to Echo users for an additional{" "}
                    {pack?.introductoryOffer?.freeMonths} months— free of
                    charge! This means extended exposure for your organization
                    at no extra cost during that time.
                  </Typography>
                  <Typography
                    sx={{
                      color: "#000000B2",
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "14px",
                        lg: "16px",
                        xl: "18px",
                      },
                      fontWeight: 700,
                      marginBottom: "15px",
                    }}
                  >
                    After the {pack?.introductoryOffer?.freeMonths}-month free
                    period, content retention fees will apply based on your
                    library size:
                  </Typography>
                </Box>
              </Box>

              {retentionPlans?.map((plan) => (
                <Box
                  key={plan.id}
                  sx={{
                    padding: "6px 12px",
                    borderRadius: "10px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    color: "#2A4876",
                  }}
                >
                  <Box sx={{ display: "flex", gap: "8px" }}>
                    <img
                      src={flightIcon}
                      style={{ width: "21px", height: "21px" }}
                    />
                  </Box>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {plan.nickname} (
                    {plan.contentSize.min === 0
                      ? 1
                      : plan.contentSize.min === 16
                        ? "16+"
                        : plan.contentSize.min}{" "}
                    {plan.contentSize.max && "-"} {plan.contentSize.max} pieces)
                    - ${plan.unit_amount / 100} / month
                  </Typography>
                </Box>
              ))}

              <Box sx={{ marginTop: "15px" }}>
                <Typography
                  sx={{
                    color: "#000000B2",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    },
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                >
                  If you’d like to continue adding new content for Echo users,
                  you will need to renew your subscription, as the{" "}
                  {pack?.introductoryOffer?.freeMonths} month period only covers
                  content retention and does not include additional content
                  uploads. We’ll send you a reminder with options as you near
                  the end of your complimentary retention period.
                </Typography>
                <Typography
                  sx={{
                    color: "#000000B2",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    },
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                >
                  Thank you for being part of the Echo community. We look
                  forward to helping your content reach even more aviation
                  professionals!
                </Typography>
              </Box>
            </>
          ) : (
            <>
              {/* ---- Alternative Content (when isActive = false) ---- */}
              <Box>
                <Box sx={{ marginBottom: "18px" }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#2A4876",
                      fontSize: {
                        xs: "18px",
                        sm: "20px",
                        md: "24px",
                        lg: "28px",
                        xl: "32px",
                      },
                    }}
                  >
                    Thank you for choosing the {pack?.name}!
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "#000000B2",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    },
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                >
                  We are excited to have you on board.
                </Typography>
                <Typography
                  sx={{
                    color: "#000000B2",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    },
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                >
                  At the end of your subscription period, if not renewed, your
                  content will remain available to Echo users based on our
                  content retention plans.
                </Typography>

                {retentionPlans?.map((plan) => (
                  <Box
                    key={plan.id}
                    sx={{
                      padding: "6px 12px",
                      borderRadius: "10px",
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      color: "#2A4876",
                    }}
                  >
                    <Box sx={{ display: "flex", gap: "8px" }}>
                      <img
                        src={flightIcon}
                        style={{ width: "21px", height: "21px" }}
                      />
                    </Box>
                    <Typography sx={{ fontWeight: "bold" }}>
                      {plan.nickname} (
                      {plan.contentSize.min === 0
                        ? 1
                        : plan.contentSize.min === 16
                          ? "16+"
                          : plan.contentSize.min}{" "}
                      {plan.contentSize.max && "-"} {plan.contentSize.max}{" "}
                      pieces) - ${plan.unit_amount / 100} / month
                    </Typography>
                  </Box>
                ))}

                <Typography
                  sx={{
                    color: "#000000B2",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    },
                    fontWeight: 400,
                    marginTop: "15px",
                    marginBottom: "15px",
                  }}
                >
                  To continue adding new content for Echo users, you will need
                  to renew your subscription, as the content retention plans do
                  not include additional content uploads. Please feel free to
                  reach out if you have any questions!
                </Typography>
                <Typography
                  sx={{
                    color: "#000000B2",
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "14px",
                      lg: "16px",
                      xl: "18px",
                    },
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                >
                  Thank you for being part of the Echo community. We look
                  forward to helping your content reach even more aviation
                  professionals!
                </Typography>
              </Box>
            </>
          )}
        </Box>

        <hr />

        <Box>
          <Typography
            sx={{
              color: "#FF6262",
              marginBottom: "10px",
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "14px",
                lg: "16px",
                xl: "18px",
              },
              fontWeight: 700,
            }}
          >
            Important:
          </Typography>
          <Typography
            sx={{
              color: "#FF6262",
              fontStyle: "italic",
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "14px",
                lg: "16px",
                xl: "18px",
              },
              fontWeight: 400,
            }}
          >
            At the end of{" "}
            {isIntroOfferActive
              ? "the free content retention period"
              : "your subscription period"}
            , the credit card on file will be charged based on the size of your
            content library. To avoid unwanted charges, either adjust your
            content library to match your preferred pricing tier or go to
            Settings {">"} Content Retention and select “Manage content” before{" "}
            {futureDate}
          </Typography>
        </Box>

        <Box sx={{ textAlign: "center" }}>
          <Button
            sx={{
              backgroundColor: "#2A4876",
              textTransform: "capitalize",
              color: "#ffffff",
              borderRadius: "34px",
              width: { xs: "90%", sm: "70%", md: "70%", lg: "370px" },
              height: "60px",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: { xs: "16px", sm: "16px", md: "18px", lg: "20px" },
              fontWeight: 700,
            }}
            onClick={onClose}
          >
            Proceed
          </Button>
          <Typography sx={{ cursor: "pointer" }} onClick={handleBack}>
            Go Back
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default IntroductoryOfferModal;
